import React, { useEffect, useState } from "react";
import Layout from "../Layout/Layout";
import { APIUrl } from "../../Helper/APIUrl";
import { useSnackbar } from "notistack";

function AMRDetails() {
    const Token = JSON.parse(localStorage.getItem("tcn"));
    const userId = JSON.parse(localStorage.getItem("userid")) || null;
    const { enqueueSnackbar } = useSnackbar();

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        AMRDetailId: 1,
        ShortDescription: "",
        Address: "",
        ContactNo: "",
        Email: "",
        Facebook: "",
        Instagram: "",
        Youtube: "",
        Twitter: "",
        EmbededMapURL: "",
        IsActive: true,
        CreatedBy: userId,
        CreatedOn: null,
        ModifyBy: userId,
        ModifiedOn: null,
    });

    const parseJSON = async (response) => {
        try {
            const text = await response.text();
            if (!text) return null;
            return JSON.parse(text);
        } catch (err) {
            console.warn("Failed to parse JSON response", err);
            return null;
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const getAMRDetailById = async () => {
        if (!Token) {
            enqueueSnackbar("Authentication token not found. Please login again.", { variant: "error" });
            return;
        }

        try {
            const response = await fetch(`${APIUrl.AMRDetail}GetAMRDetailById/1`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${Token}`,
                },
                body: JSON.stringify({}),
            });

            const result = await parseJSON(response);
            const detail = Array.isArray(result?.data) ? result.data[0] : result?.data;

            if (detail) {
                setFormData((prev) => ({
                    ...prev,
                    AMRDetailId: detail.AMRDetailId ?? 1,
                    ShortDescription: detail.ShortDescription ?? "",
                    Address: detail.Address ?? "",
                    ContactNo: detail.ContactNo ?? "",
                    Email: detail.Email ?? "",
                    Facebook: detail.Facebook ?? "",
                    Instagram: detail.Instagram ?? "",
                    Youtube: detail.Youtube ?? "",
                    Twitter: detail.Twitter ?? "",
                    EmbededMapURL: detail.EmbededMapURL ?? "",
                    IsActive: detail.IsActive ?? true,
                    CreatedBy: detail.CreatedBy ?? userId,
                    CreatedOn: detail.CreatedOn ?? null,
                    ModifyBy: userId,
                    ModifiedOn: detail.ModifiedOn ?? null,
                }));
            }
        } catch (error) {
            console.error("Error fetching AMR detail:", error);
            enqueueSnackbar("Unable to load AMR Detail data", { variant: "error" });
        }
    };

    useEffect(() => {
        getAMRDetailById();
    }, []);

    const validateForm = () => {
        if (!formData.ShortDescription || formData.ShortDescription.trim().length < 3) {
            enqueueSnackbar("Short Description must be at least 3 characters", { variant: "warning" });
            return false;
        }

        if (!formData.ContactNo || formData.ContactNo.trim().length < 10) {
            enqueueSnackbar("Please enter a valid contact number", { variant: "warning" });
            return false;
        }

        if (formData.Email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(formData.Email)) {
                enqueueSnackbar("Please enter a valid email address", { variant: "warning" });
                return false;
            }
        }

        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!Token) {
            enqueueSnackbar("Authentication token not found. Please login again.", { variant: "error" });
            return;
        }

        if (!validateForm()) {
            return;
        }

        const payload = {
            ...formData,
            AMRDetailId: 1,
            CreatedBy: userId,
            ModifyBy: userId,
            CreatedOn: null,
            ModifiedOn: null,
        };

        try {
            setIsSubmitting(true);

            const response = await fetch(`${APIUrl.AMRDetail}UpdateAMRDetail/1`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${Token}`,
                },
                body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (response.ok && result && (result.isSuccess || result.Message === "Success")) {
                enqueueSnackbar("AMR Detail saved successfully", { variant: "success" });
            } else {
                enqueueSnackbar(result?.Message || "Failed to save AMR Detail", { variant: "error" });
            }
        } catch (error) {
            console.error("AMR Detail upsert error:", error);
            enqueueSnackbar("Error while saving AMR Detail", { variant: "error" });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Layout>
            <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
                <div className="max-w-5xl mx-auto space-y-6">
                    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                        <div className="px-6 py-5 border-b border-gray-200 bg-white">
                            <h1 className="text-2xl font-bold text-gray-900">AMR Detail</h1>
                            <p className="text-sm text-gray-600 mt-1">
                                Update AMR information
                            </p>
                        </div>

                        <form onSubmit={handleSubmit} className="p-6 space-y-6">
                            <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
                                <div className="md:col-span-12">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Short Description</label>
                                    <input
                                        type="text"
                                        name="ShortDescription"
                                        value={formData.ShortDescription}
                                        onChange={handleChange}
                                        className="w-full rounded-lg border border-gray-300 px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        placeholder="Enter short description"
                                    />
                                </div>
                                <div className="md:col-span-6">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Official Email</label>
                                    <input
                                        type="email"
                                        name="Email"
                                        value={formData.Email}
                                        onChange={handleChange}
                                        className="w-full rounded-lg border border-gray-300 px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        placeholder="Enter email"
                                    />
                                </div>
                                <div className="md:col-span-6">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Official Contact No</label>
                                    <input
                                        type="text"
                                        name="ContactNo"
                                        value={formData.ContactNo}
                                        onChange={handleChange}
                                        className="w-full rounded-lg border border-gray-300 px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        placeholder="Enter contact number"
                                    />
                                </div>

                                <div className="md:col-span-12">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Official Address</label>
                                    <input
                                        type="text"
                                        name="Address"
                                        value={formData.Address}
                                        onChange={handleChange}
                                        className="w-full rounded-lg border border-gray-300 px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        placeholder="Enter address"
                                    />
                                </div>

                                <div className="md:col-span-12">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Facebook Link</label>
                                    <input
                                        type="text"
                                        name="Facebook"
                                        value={formData.Facebook}
                                        onChange={handleChange}
                                        className="w-full rounded-lg border border-gray-300 px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        placeholder="Facebook URL"
                                    />
                                </div>

                                <div className="md:col-span-12">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Instagram Link</label>
                                    <input
                                        type="text"
                                        name="Instagram"
                                        value={formData.Instagram}
                                        onChange={handleChange}
                                        className="w-full rounded-lg border border-gray-300 px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        placeholder="Instagram URL"
                                    />
                                </div>

                                <div className="md:col-span-12">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Youtube Link</label>
                                    <input
                                        type="text"
                                        name="Youtube"
                                        value={formData.Youtube}
                                        onChange={handleChange}
                                        className="w-full rounded-lg border border-gray-300 px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        placeholder="Youtube URL"
                                    />
                                </div>

                                <div className="md:col-span-12">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Twitter Link</label>
                                    <input
                                        type="text"
                                        name="Twitter"
                                        value={formData.Twitter}
                                        onChange={handleChange}
                                        className="w-full rounded-lg border border-gray-300 px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        placeholder="Twitter URL"
                                    />
                                </div>

                                <div className="md:col-span-12">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Embed Google Map URL</label>
                                    <textarea
                                        name="EmbededMapURL"
                                        value={formData.EmbededMapURL}
                                        onChange={handleChange}
                                        rows={3}
                                        className="w-full rounded-lg border border-gray-300 px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        placeholder="Paste the Google Map embed URL here"
                                    />
                                </div>

                            </div>

                            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 border-t border-gray-200 pt-5">

                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-60"
                                >
                                    {isSubmitting ? "Saving..." : "Save AMR Detail"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
        </Layout>
    );
}

export default AMRDetails;
